import { forwardRef, useImperativeHandle, useState } from "react";
import { Modal as ModalBootstrap } from "react-bootstrap";
import { ExButton } from "../ExButton";
import { Title, Icon, HeaderRight } from "./components";

export interface ModalRef {
    openModal: () => void;
    closeModal: () => void;
    setLoading: (loading: boolean) => void;
}

export const Modal = forwardRef<ModalRef, any>((props, ref) => {
    const [show, setShow] = useState(false);
    const [loading, setLoading] = useState(false);

    function openModal() {
        setShow(true);
    }

    function closeModal() {
        setShow(false);
    }

    useImperativeHandle(ref, () => ({
        openModal,
        closeModal,
        setLoading
    }));

    return (
        <ModalBootstrap
            show={props.show || show}
            onHide={() => props.onHide ? props.onHide() : closeModal()}
            backdrop={props.backdrop || 'static'}
            centered={props.top ? false : true}
            size={props.size ? props.size : undefined}
            fullscreen={props.fullscreen ? props.fullscreen : undefined}
        >
            {props.title &&
                <ModalBootstrap.Header className="p-3 d-flex justify-content-between align-items-center">
                    <Title>
                        <Icon>{props?.icon}</Icon>
                        {props.title}
                    </Title>
                    {props.header && <HeaderRight>{props.header()}</HeaderRight>}
                </ModalBootstrap.Header>
            }
            <ModalBootstrap.Body>
                {props.children}
            </ModalBootstrap.Body>
            <fieldset disabled={loading} >
                <ModalBootstrap.Footer>
                    <ExButton secondary onClick={() => props.cancel ? props.cancel() : closeModal()}>Cancelar</ExButton>
                    {props.success && <ExButton onClick={() => props.success()}>Confirmar</ExButton>}
                </ModalBootstrap.Footer>
            </fieldset>
        </ModalBootstrap>
    );
});
